import React from 'react';

export default function LookupFormatter({ row, column, lookup }) {
  return (
    <span>{ lookup[row[column.key]] || row[column.key] }</span>
  );
}
